
export const areas: any = {
	1: { color: "#FFA02E", "trajectory": "Financeira", },
	2: { color: "#FA4549", "trajectory": "Gestão de pessoas", },
	3: { color: "#A25AF1", "trajectory": "Negócios", },
	4: { color: "#4AC8F5", "trajectory": "Tecnologia", },
}

export const colorsMaps = [
	{
			trajectory: "Financeira",
			trajectory_id: 1,
			color: "#FFA02E",
			border_color: "#FFD181",
	},
	{
			trajectory: "Gestão de pessoas",
			trajectory_id: 2,
			color: "#FA4549",
			border_color: "#FF8182",
	},
	{
			trajectory: "Negócios",
			trajectory_id: 3,
			color: "#A25AF1",
			border_color: "#CDABF1",
	},
	{
			trajectory: "Tecnologia",
			trajectory_id: 4,
			color: "#4AC8F5",
			border_color: "#A6E8FF",
	},
];